import { JSONSchemaProp } from 'models';
import { translate } from 'utils';

export const translateTitleInScheme = (prop?: JSONSchemaProp, replace?: string[]) => {
  if (prop) {
    return translate({ key: prop.title_translation_key, fallback: prop.title, replace });
  }
  return '';
};
